var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"outlined":"","text":"","type":_vm.data.type}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.msg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }